import script from "./EcommerceTest.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceTest.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceTest.vue?vue&type=style&index=0&id=4d9965ce&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d9965ce"]])

export default __exports__